/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react'

import { BsSearch } from 'react-icons/bs'
import {
  Container,
  HeaderCard,
  Search,
  CardBody,
  TitleCard,
  ContentCard,
  HeaderContendCard,
  FooterCard,
  Card,
  EmptyText,
} from './styles'
import { useDispatch } from 'react-redux'

import history from '../../../../services/history'
import { changeRecentPath } from '../../../../store/modules/recentView/action'
import { useGetDoubts } from 'pages/DoubtsList/hooks/use-get-doubts'
import { StudentDoubt } from 'pages/Doubt/types'

const DoubtListComponent: React.FC = () => {
  const [inputText, setInputText] = useState('')
  const dispatch = useDispatch()

  const swrDoubts = useGetDoubts(inputText)
  const isLoading = swrDoubts.isLoading
  const doubts = swrDoubts.isLoading ? [] : swrDoubts.data

  function getDate(date: string) {
    const stringForDate = new Date(date)
    const DateFormat = new Intl.DateTimeFormat('pt-BR', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    }).format(stringForDate)

    return DateFormat
  }

  const handleChange = (e) => {
    setInputText(e.target.value)
  }

  return (
    <Container>
      <HeaderCard>
        <Search>
          <div className="svgContainer">
            <BsSearch />
          </div>
          <input placeholder="Buscar dúvida" onChange={handleChange} type="search" />
        </Search>

        <h1>Dúvidas</h1>
      </HeaderCard>
      {isLoading && (
        <EmptyText>
          {' '}
          <h1 className="empty-text loading">Carregando suas dúvidas...</h1>
        </EmptyText>
      )}
      {doubts.length > 0 && !isLoading && (
        <Card>
          {doubts.map((item: StudentDoubt, idx: number) => (
            <CardBody key={idx}>
              <TitleCard>
                <h2>
                  Dúvida #{item.code}
                  <div id={item.title}></div>
                </h2>
                <span>{item.status === 1 ? 'Respondida' : ''}</span>
                <span className="type">
                  {item.objectType === 'excerpt' ? 'Livro Digital' : 'Vídeo'}
                </span>
              </TitleCard>
              <ContentCard className="body">
                <HeaderContendCard>
                  <div>
                    <p>
                      <b>{item?.course?.name}</b>
                    </p>
                    <p>
                      <strong>Módulo:</strong>
                      {item?.studyModule?.subject || item?.studyModule?.name}
                    </p>
                    <p>
                      <strong>Aula:</strong>
                      {item?.lesson?.heading || item?.lesson?.name}
                    </p>
                    <p>
                      <strong>Capítulo:</strong>
                      {item?.minimumApprenticeshipUnit?.heading ||
                        item?.minimumApprenticeshipUnit?.name}
                    </p>
                    <p className="text-doubt">{item.title}</p>
                  </div>
                </HeaderContendCard>
                <button
                  onClick={() => {
                    dispatch(changeRecentPath(`/duvidas`))

                    history.push({
                      pathname: `/course/${item?.course?._id}/module/${item?.studyModule?._id}/lesson/${item?.lesson?._id}/chapter/${item?.minimumApprenticeshipUnit?._id}`,
                      state: { lessonType: `${item?.objectType}` },
                    })
                  }}
                >
                  Ir para a aula
                </button>
              </ContentCard>
              <FooterCard>
                <p>{`Enviada em ${getDate(item.createdAt)}`}</p>
                <button
                  onClick={() => history.push(`/duvida-respondida/${item?._id}/${item.code}`)}
                >
                  Ver mais
                </button>
              </FooterCard>
            </CardBody>
          ))}
        </Card>
      )}
      {doubts.length === 0 && !isLoading && (
        <EmptyText>
          {' '}
          <h1 className="empty-text">Você não possui dúvidas enviadas</h1>
        </EmptyText>
      )}
    </Container>
  )
}

export default DoubtListComponent
